import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Faq from "../component/Faq";

export default function FaqPage(props) {
  return (
    <Container maxWidth="md">
      <Box mt={6} mb={2}>
        <Typography variant="h1" gutterBottom>
          FAQs
        </Typography>
      </Box>
      <Faq />
    </Container>
  );
}
